// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ConfidenceLevelSchema = z.enum(['LOW','MEDIUM','HIGH'] as const);

export type ConfidenceLevelType = `${z.infer<typeof ConfidenceLevelSchema>}`

export default ConfidenceLevelSchema;
